import React from 'react';
import Logo from '../../Logo'
import { Box, IconButton, Drawer } from '@mui/material';
import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom';
import MenuBox from './MenuBox';
import MenuIcon from '@mui/icons-material/Menu'
import BtnBox from './BtnBox';

const TopBar = ({ isMobile }) => {
    const [drawerOpen, setDrawerOpen] = useState(false)
    const location = useLocation()
    const closeDrawer = () => setDrawerOpen(false)

    useEffect(() => {
        setDrawerOpen(false)
    }, [location.pathname])

    const handleDrawer = () => {
        setDrawerOpen((prev) => !prev)
    }

    return (
        <>
            {isMobile && (
                <Drawer
                    anchor="left"
                    open={drawerOpen}
                    onClose={closeDrawer}
                    PaperProps={{ style: { width: 250 } }}
                >
                    <MenuBox isMobile={isMobile} onNavigate={closeDrawer} />
                </Drawer>
            )}

            <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                gap={3}
                borderBottom={isMobile ? 'none' : '1px solid'}
                borderColor="divider"
                pb={isMobile ? 0 : 2}
            >
                <Box
                    display="flex"
                    alignItems="center"
                    gap={1}
                >
                    {
                        isMobile && (
                            <IconButton onClick={handleDrawer}>
                                <MenuIcon />
                            </IconButton>
                        )
                    }
                    <Logo isMobile={isMobile} />
                </Box>

                {
                    !isMobile && (
                        <MenuBox isMobile={isMobile} />
                    )
                }

                <BtnBox isMobile={isMobile} />

            </Box>
        </>
    );
};

export default TopBar;